export default __webpack_public_path__ + "assets/b02d29418021edae4749ae26e9d0850f.svg";